import type {FC} from 'react';

import PersonList from '../../components/person-list/PersonList';

import {personListFromPersonListSelectionSection, type PersonListSelectionFragment} from './query';

type Props = {
	data: PersonListSelectionFragment;
};

export const PersonListSelectionContainer: FC<Props> = ({data}) => {
	return (
		<PersonList
			people={personListFromPersonListSelectionSection(data)}
			title={data.title}
			spacingBottom={data.layout?.spacingBottom}
			spacingTop={data.layout?.spacingTop}
		/>
	);
};
